import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
    view: null,
    googlePlaceId: null,
    googlePlaceName: null,
    googlePlaceAddress: null,
    googlePlaceRating: null,
    googlePlaceReviewCount: null,
    googlePlacePhoto: null,
    googlePlaceUrl: null,
  },
  blockDesign: {
    layout: 'feed',
  },
  itemDesign: {},
  containerDesign: {},
};

export const reviewSlice = createSlice({
  name: 'review',
  initialState,
  reducers: {
    reviewStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const blockContent = block.blockContent ?? {};
      const blockDesign = block.blockDesign ?? {};
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        items: blockContent.items ?? [],
        heading: {
          title: blockContent.heading?.title ?? '',
          description: blockContent.heading?.description ?? '',
          textAlign: blockContent.heading?.textAlign ?? 'left',
          image: blockContent.heading?.image ?? '',
          divider: blockContent.heading?.divider ?? '',
          position: blockContent.heading?.position ?? '',
        },
        view: blockContent.view ?? null,
        googlePlaceId: blockContent.googlePlaceId ?? null,
        googlePlaceName: blockContent.googlePlaceName ?? null,
        googlePlaceAddress: blockContent.googlePlaceAddress ?? null,
        googlePlaceRating: blockContent.googlePlaceRating ?? null,
        googlePlaceReviewCount: blockContent.googlePlaceReviewCount ?? null,
        googlePlacePhoto: blockContent.googlePlacePhoto ?? null,
        googlePlaceUrl: blockContent.googlePlaceUrl ?? null,
      };
      state.blockDesign = {
        layout: blockDesign.layout ?? 'feed',
      };
    },
    reviewClear: () => initialState,

    reviewUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    reviewUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    reviewUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    reviewUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
    reviewAddItem: (state, action) => {
      state.blockContent.items.push(action.payload);
    },
    reviewSetItems: (state, action) => {
      state.blockContent.items = action.payload ?? [];
    },
  },
});

export const { reviewStore, reviewClear, reviewUpdateIsLoading, reviewUpdateIsActive, reviewUpdateBlockContent, reviewUpdateBlockDesign, reviewAddItem, reviewSetItems } =
  reviewSlice.actions;

export const selectReviewIsLoading = (state) => state.review.isLoading;

export const selectReviewId = (state) => state.review.id;
export const selectReviewUID = (state) => state.review.uid;
export const selectReviewSID = (state) => state.review.sid;

export const selectReviewBlockContent = (state) => state.review.blockContent;
export const selectReviewView = (state) => state.review.blockContent.view;
export const selectReviewBlockDesign = (state) => state.review.blockDesign;
export const selectReviewSortItems = createSelector([selectReviewBlockContent], ({ items }) => {
  return sortItems(items);
});
export const selectReviewItemDesign = (state) => state.review.itemDesign;
export const selectReviewContainerDesign = (state) => state.review.containerDesign;

export default reviewSlice.reducer;
